import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: modules,
  state: {
    appTitle: 'C.S. Kim Karate Fort Wayne',
    loading: true
  },
  getters: {
    getLoading(state) {
      return state.loading;
    }
  },
  mutations: {
    setLoading(state, tf) {
      state.loading = tf;
    }
  }
});

export default store;